// AUTO-GENERATED by scripts/generate-nav.mjs — DO NOT EDIT
// Regenerated on each sync run in CI
import type { Navigation } from "zudoku";

export const generatedRepoNav: Navigation = [
  {
    "type": "category",
    "label": "Backend",
    "icon": "server",
    "collapsed": true,
    "items": [
      "backend/guide/rbac",
      "backend/guide/collaboration",
      "backend/guide/modules",
      "backend/guide/security-and-mfa",
      {
        "type": "category",
        "label": "Generated",
        "items": [
          "backend/guide/generated/users",
          "backend/guide/generated/users-create",
          "backend/guide/generated/users-edit",
          "backend/guide/generated/roles",
          "backend/guide/generated/roles-create",
          "backend/guide/generated/roles-edit",
          "backend/guide/generated/organizations",
          "backend/guide/generated/organizations-create",
          "backend/guide/generated/organizations-edit",
          "backend/guide/generated/customers",
          "backend/guide/generated/configurations",
          "backend/guide/generated/configurations-create",
          "backend/guide/generated/modules",
          "backend/guide/generated/modules-edit",
          "backend/guide/generated/profile",
          "backend/guide/generated/entity-field-reference",
          "backend/guide/generated/filter-operator-reference",
          "backend/guide/generated/filter-syntax-guide",
          "backend/guide/generated/navigation-map",
          "backend/guide/generated/entity-api-catalog",
          "backend/guide/generated/clients-create",
          "backend/guide/generated/clients-edit",
          "backend/guide/generated/clients"
        ]
      },
      {
        "type": "category",
        "label": "Manual",
        "items": [
          "backend/guide/manual/migrations"
        ]
      },
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "backend/dev/overview",
          "backend/dev/architecture",
          "backend/dev/api-conventions",
          "backend/dev/entity-metadata",
          "backend/dev/entity-crud-pipeline",
          "backend/dev/entities-crud",
          "backend/dev/module-navigation",
          "backend/dev/service-registry",
          "backend/dev/mcp",
          "backend/dev/proxy",
          "backend/dev/secrets-engine",
          "backend/dev/translations",
          "backend/dev/authentication",
          "backend/dev/rbac",
          "backend/dev/environment-configuration",
          "backend/dev/collaboration"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "Frontend",
    "icon": "monitor",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "frontend/dev/overview",
          "frontend/dev/getting-started",
          "frontend/dev/ui-stack",
          "frontend/dev/app-shell",
          "frontend/dev/authentication",
          "frontend/dev/settings",
          "frontend/dev/ui-components",
          "frontend/dev/ui-patterns",
          "frontend/dev/icon-conventions",
          "frontend/dev/input-anatomy",
          "frontend/dev/field-hints",
          "frontend/dev/button-styles",
          "frontend/dev/entity-metadata",
          "frontend/dev/i18n",
          "frontend/dev/ai-tool-loop",
          "frontend/dev/error-handling",
          "frontend/dev/composables",
          {
            "type": "category",
            "label": "Components",
            "items": [
              "frontend/dev/components/entity-list-table",
              "frontend/dev/components/combo-select",
              "frontend/dev/components/dynamic-icon",
              "frontend/dev/components/color-selector",
              "frontend/dev/components/color-picker",
              "frontend/dev/components/avatar-preview",
              "frontend/dev/components/event-card",
              "frontend/dev/components/command-palette",
              "frontend/dev/components/app-shell",
              "frontend/dev/components/app-sidebar",
              "frontend/dev/components/app-topbar",
              "frontend/dev/components/app-page-layout",
              "frontend/dev/components/app-page-scaffold",
              "frontend/dev/components/app-page-breadcrumb",
              "frontend/dev/components/app-server-banner",
              "frontend/dev/components/browser-client-info",
              "frontend/dev/components/lang-select",
              "frontend/dev/components/theme-toggle",
              "frontend/dev/components/sidebar-app-launcher",
              "frontend/dev/components/sidebar-health-badge",
              "frontend/dev/components/sidebar-org-switcher",
              "frontend/dev/components/sidebar-profile-menu",
              "frontend/dev/components/sidebar-version-badge",
              "frontend/dev/components/button",
              "frontend/dev/components/button-async",
              "frontend/dev/components/form-page-layout",
              "frontend/dev/components/form-label-with-priority-help",
              "frontend/dev/components/password-checklist",
              "frontend/dev/components/choicebox",
              "frontend/dev/components/date-wheel-picker",
              "frontend/dev/components/event-toast",
              "frontend/dev/components/loading-bar",
              "frontend/dev/components/metadata-loading",
              "frontend/dev/components/json-table-viewer",
              "frontend/dev/components/number-ticker",
              "frontend/dev/components/stat-card",
              "frontend/dev/components/toolbar",
              "frontend/dev/components/dialog-bordered",
              "frontend/dev/components/entity-confirm-dialogs",
              "frontend/dev/components/sheet-panel",
              "frontend/dev/components/rfc-error-dialog",
              "frontend/dev/components/login-form",
              "frontend/dev/components/passkey-button",
              "frontend/dev/components/passkey-enrollment",
              "frontend/dev/components/auth-methods-prompt-dialog",
              "frontend/dev/components/session-expired-dialog",
              "frontend/dev/components/input",
              "frontend/dev/components/slider",
              "frontend/dev/components/slider-field",
              "frontend/dev/components/switch-field",
              "frontend/dev/components/selectable-fieldset",
              "frontend/dev/components/badge-values-editor",
              "frontend/dev/components/tooltip",
              "frontend/dev/components/form",
              "frontend/dev/components/prime-field",
              "frontend/dev/components/smart-regex-input"
            ]
          },
          "frontend/dev/api-reference"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "Microservices",
    "icon": "boxes",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "microservices/dev/overview",
          "microservices/dev/architecture",
          "microservices/dev/conventions",
          "microservices/dev/adding-a-service",
          {
            "type": "category",
            "label": "Services",
            "items": [
              "microservices/dev/services/ai/docs-kb",
              "microservices/dev/services/emailsender/providers"
            ]
          }
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "DAL Library",
    "icon": "database",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "dal/dev/getting-started",
          "dal/dev/architecture",
          "dal/dev/entities",
          "dal/dev/column-types",
          "dal/dev/query-dsl",
          "dal/dev/repository",
          "dal/dev/repository-pattern",
          "dal/dev/entity-service",
          "dal/dev/connections",
          "dal/dev/audit-trail",
          "dal/dev/partitioning",
          "dal/dev/optimistic-lock",
          "dal/dev/clone",
          "dal/dev/migrations",
          "dal/dev/changelog",
          "dal/dev/api-reference"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "SDK Library",
    "icon": "package",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "sdk/dev/overview",
          "sdk/dev/getting-started",
          "sdk/dev/microservice-anatomy",
          "sdk/dev/authentication",
          "sdk/dev/client-shield-and-secrets",
          "sdk/dev/http-server",
          "sdk/dev/rpc-router",
          "sdk/dev/entity-router",
          "sdk/dev/openapi-generation",
          "sdk/dev/docs-pack",
          "sdk/dev/config-tables",
          "sdk/dev/migrations",
          "sdk/dev/translations",
          "sdk/dev/currency",
          "sdk/dev/nats-client",
          "sdk/dev/service-registration",
          "sdk/dev/sse-standard",
          "sdk/dev/presence",
          "sdk/dev/ext-json",
          "sdk/dev/cache-layer",
          "sdk/dev/telemetry-logging",
          "sdk/dev/api-reference"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "Decimal Library",
    "icon": "calculator",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "decimal/dev/getting-started",
          "decimal/dev/precision-model",
          "decimal/dev/division-and-periodicity",
          "decimal/dev/rounding",
          "decimal/dev/wire-format",
          "decimal/dev/when-to-use",
          "decimal/dev/when-not-to-use",
          "decimal/dev/examples",
          "decimal/dev/api-reference",
          "decimal/dev/contributing"
        ]
      }
    ]
  }
];

// Split for stacked navigation by explicit group tag (service vs library).
// Position-independent: a filtered-out repo can never shift another repo
// into the wrong sidebar group.
export const serviceNav: Navigation = [
  {
    "type": "category",
    "label": "Backend",
    "icon": "server",
    "collapsed": true,
    "items": [
      "backend/guide/rbac",
      "backend/guide/collaboration",
      "backend/guide/modules",
      "backend/guide/security-and-mfa",
      {
        "type": "category",
        "label": "Generated",
        "items": [
          "backend/guide/generated/users",
          "backend/guide/generated/users-create",
          "backend/guide/generated/users-edit",
          "backend/guide/generated/roles",
          "backend/guide/generated/roles-create",
          "backend/guide/generated/roles-edit",
          "backend/guide/generated/organizations",
          "backend/guide/generated/organizations-create",
          "backend/guide/generated/organizations-edit",
          "backend/guide/generated/customers",
          "backend/guide/generated/configurations",
          "backend/guide/generated/configurations-create",
          "backend/guide/generated/modules",
          "backend/guide/generated/modules-edit",
          "backend/guide/generated/profile",
          "backend/guide/generated/entity-field-reference",
          "backend/guide/generated/filter-operator-reference",
          "backend/guide/generated/filter-syntax-guide",
          "backend/guide/generated/navigation-map",
          "backend/guide/generated/entity-api-catalog",
          "backend/guide/generated/clients-create",
          "backend/guide/generated/clients-edit",
          "backend/guide/generated/clients"
        ]
      },
      {
        "type": "category",
        "label": "Manual",
        "items": [
          "backend/guide/manual/migrations"
        ]
      },
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "backend/dev/overview",
          "backend/dev/architecture",
          "backend/dev/api-conventions",
          "backend/dev/entity-metadata",
          "backend/dev/entity-crud-pipeline",
          "backend/dev/entities-crud",
          "backend/dev/module-navigation",
          "backend/dev/service-registry",
          "backend/dev/mcp",
          "backend/dev/proxy",
          "backend/dev/secrets-engine",
          "backend/dev/translations",
          "backend/dev/authentication",
          "backend/dev/rbac",
          "backend/dev/environment-configuration",
          "backend/dev/collaboration"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "Frontend",
    "icon": "monitor",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "frontend/dev/overview",
          "frontend/dev/getting-started",
          "frontend/dev/ui-stack",
          "frontend/dev/app-shell",
          "frontend/dev/authentication",
          "frontend/dev/settings",
          "frontend/dev/ui-components",
          "frontend/dev/ui-patterns",
          "frontend/dev/icon-conventions",
          "frontend/dev/input-anatomy",
          "frontend/dev/field-hints",
          "frontend/dev/button-styles",
          "frontend/dev/entity-metadata",
          "frontend/dev/i18n",
          "frontend/dev/ai-tool-loop",
          "frontend/dev/error-handling",
          "frontend/dev/composables",
          {
            "type": "category",
            "label": "Components",
            "items": [
              "frontend/dev/components/entity-list-table",
              "frontend/dev/components/combo-select",
              "frontend/dev/components/dynamic-icon",
              "frontend/dev/components/color-selector",
              "frontend/dev/components/color-picker",
              "frontend/dev/components/avatar-preview",
              "frontend/dev/components/event-card",
              "frontend/dev/components/command-palette",
              "frontend/dev/components/app-shell",
              "frontend/dev/components/app-sidebar",
              "frontend/dev/components/app-topbar",
              "frontend/dev/components/app-page-layout",
              "frontend/dev/components/app-page-scaffold",
              "frontend/dev/components/app-page-breadcrumb",
              "frontend/dev/components/app-server-banner",
              "frontend/dev/components/browser-client-info",
              "frontend/dev/components/lang-select",
              "frontend/dev/components/theme-toggle",
              "frontend/dev/components/sidebar-app-launcher",
              "frontend/dev/components/sidebar-health-badge",
              "frontend/dev/components/sidebar-org-switcher",
              "frontend/dev/components/sidebar-profile-menu",
              "frontend/dev/components/sidebar-version-badge",
              "frontend/dev/components/button",
              "frontend/dev/components/button-async",
              "frontend/dev/components/form-page-layout",
              "frontend/dev/components/form-label-with-priority-help",
              "frontend/dev/components/password-checklist",
              "frontend/dev/components/choicebox",
              "frontend/dev/components/date-wheel-picker",
              "frontend/dev/components/event-toast",
              "frontend/dev/components/loading-bar",
              "frontend/dev/components/metadata-loading",
              "frontend/dev/components/json-table-viewer",
              "frontend/dev/components/number-ticker",
              "frontend/dev/components/stat-card",
              "frontend/dev/components/toolbar",
              "frontend/dev/components/dialog-bordered",
              "frontend/dev/components/entity-confirm-dialogs",
              "frontend/dev/components/sheet-panel",
              "frontend/dev/components/rfc-error-dialog",
              "frontend/dev/components/login-form",
              "frontend/dev/components/passkey-button",
              "frontend/dev/components/passkey-enrollment",
              "frontend/dev/components/auth-methods-prompt-dialog",
              "frontend/dev/components/session-expired-dialog",
              "frontend/dev/components/input",
              "frontend/dev/components/slider",
              "frontend/dev/components/slider-field",
              "frontend/dev/components/switch-field",
              "frontend/dev/components/selectable-fieldset",
              "frontend/dev/components/badge-values-editor",
              "frontend/dev/components/tooltip",
              "frontend/dev/components/form",
              "frontend/dev/components/prime-field",
              "frontend/dev/components/smart-regex-input"
            ]
          },
          "frontend/dev/api-reference"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "Microservices",
    "icon": "boxes",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "microservices/dev/overview",
          "microservices/dev/architecture",
          "microservices/dev/conventions",
          "microservices/dev/adding-a-service",
          {
            "type": "category",
            "label": "Services",
            "items": [
              "microservices/dev/services/ai/docs-kb",
              "microservices/dev/services/emailsender/providers"
            ]
          }
        ]
      }
    ]
  }
];
export const libraryNav: Navigation = [
  {
    "type": "category",
    "label": "DAL Library",
    "icon": "database",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "dal/dev/getting-started",
          "dal/dev/architecture",
          "dal/dev/entities",
          "dal/dev/column-types",
          "dal/dev/query-dsl",
          "dal/dev/repository",
          "dal/dev/repository-pattern",
          "dal/dev/entity-service",
          "dal/dev/connections",
          "dal/dev/audit-trail",
          "dal/dev/partitioning",
          "dal/dev/optimistic-lock",
          "dal/dev/clone",
          "dal/dev/migrations",
          "dal/dev/changelog",
          "dal/dev/api-reference"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "SDK Library",
    "icon": "package",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "sdk/dev/overview",
          "sdk/dev/getting-started",
          "sdk/dev/microservice-anatomy",
          "sdk/dev/authentication",
          "sdk/dev/client-shield-and-secrets",
          "sdk/dev/http-server",
          "sdk/dev/rpc-router",
          "sdk/dev/entity-router",
          "sdk/dev/openapi-generation",
          "sdk/dev/docs-pack",
          "sdk/dev/config-tables",
          "sdk/dev/migrations",
          "sdk/dev/translations",
          "sdk/dev/currency",
          "sdk/dev/nats-client",
          "sdk/dev/service-registration",
          "sdk/dev/sse-standard",
          "sdk/dev/presence",
          "sdk/dev/ext-json",
          "sdk/dev/cache-layer",
          "sdk/dev/telemetry-logging",
          "sdk/dev/api-reference"
        ]
      }
    ]
  },
  {
    "type": "category",
    "label": "Decimal Library",
    "icon": "calculator",
    "collapsed": true,
    "items": [
      {
        "type": "category",
        "label": "Developer Guide",
        "collapsed": true,
        "items": [
          "decimal/dev/getting-started",
          "decimal/dev/precision-model",
          "decimal/dev/division-and-periodicity",
          "decimal/dev/rounding",
          "decimal/dev/wire-format",
          "decimal/dev/when-to-use",
          "decimal/dev/when-not-to-use",
          "decimal/dev/examples",
          "decimal/dev/api-reference",
          "decimal/dev/contributing"
        ]
      }
    ]
  }
];
